import React from 'react';
import { Loader, Pagination } from "semantic-ui-react";
import billing from "../../../api/billing";
import './DataTable.css'

class Datatable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: "",
            record: {},
            total: 0,
            total_min: 0,
            is_plg_user: false,
            mins_in_plan: 0,
            mins_used: 0,
            remaining_calls: 0,
            addon_calls: 0,
            addon_purchases: [],
            addonPage: 1,
            addonPageSize: 5,
            addonTotal: 0,
            addonTotalPages: 1,
            addonLoading: false,
            carryforward_calls: 0,
            usage_percentage: 0,
            cycle_start_date: null,
            cycle_end_date: null,
            loading: true,
            refreshing: false,
            curPlan:null,
            plan_price: 0,
            plan_calls_included: 0,
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.refreshKey !== this.props.refreshKey) {
            this.loadData(true);
            return;
        }

        const prevPlanCode = prevProps.billingdetails?.userBillingDetail?.plg_plan;
        const nextPlanCode = this.props.billingdetails?.userBillingDetail?.plg_plan;
        const prevCurrentPlan = prevProps.billingdetails?.currentPlan?.code;
        const nextCurrentPlan = this.props.billingdetails?.currentPlan?.code;

        if (prevPlanCode !== nextPlanCode || prevCurrentPlan !== nextCurrentPlan) {
            this.loadData(true);
        }
    }

    loadData = (silent = false) => {
        if (silent) {
            this.setState({ refreshing: true });
        } else {
            this.setState({ loading: true });
        }
        const { addonPage, addonPageSize } = this.state;
        const data = {
            userId: this.props.userid,
            addon_page: addonPage,
            addon_per_page: addonPageSize,
        };

        billing.GetMonthlyvoiceUsage(data)
            .then((resp) => {
                if (resp.status) {
                    const isPlg = resp?.is_plg_user ?? false;

                    if (isPlg) {
                        this.setState({
                            record: resp?.data ?? resp.data,
                            total: resp?.total ?? 0,
                            loading: false,
                            refreshing: false,
                            error: "",
                            is_plg_user: true,
                            mins_in_plan: resp?.mins_in_plan ?? 0,
                            total_min: resp?.total_mins ?? 0,
                            mins_used: resp?.mins_used ?? 0,
                            remaining_calls: resp?.remaining_calls ?? 0,
                            addon_calls: resp?.addon_calls ?? 0,
                            addon_purchases: resp?.addon_purchases ?? [],
                            addonTotal: resp?.addon_total ?? 0,
                            addonPage: resp?.addon_page ?? 1,
                            addonTotalPages: resp?.addon_total_pages ?? 1,
                            carryforward_calls: resp?.carryforward_calls ?? 0,
                            usage_percentage: resp?.usage_percentage ?? 0,
                            cycle_start_date: resp?.cycle_start_date ?? null,
                            cycle_end_date: resp?.cycle_end_date ?? null,
                            curPlan: resp.plg_plan ?? null,
                            plan_price: resp?.plan_price ?? 0,
                            plan_calls_included: resp?.plan_calls_included ?? 0,
                        });
                    } else {
                        this.setState({
                            record: resp?.data ?? resp.data,
                            total: resp?.total ?? 0,
                            loading: false,
                            refreshing: false,
                            error: "",
                            total_min: resp?.total_mins ?? 0,
                            is_plg_user: false,
                        });
                    }
                } else {
                    this.setState({
                        record: { mins_in_plan: 0 },
                        total: 0,
                        loading: false,
                        refreshing: false,
                        error: "",
                        total_min: 0,
                        is_plg_user: false,
                    });
                }
            });
    }

    loadAddonPage = (page) => {
        this.setState({ addonLoading: true, addonPage: page }, () => {
            const { addonPage, addonPageSize } = this.state;
            const data = {
                userId: this.props.userid,
                addon_page: addonPage,
                addon_per_page: addonPageSize,
            };
            billing.GetMonthlyvoiceUsage(data).then((resp) => {
                if (resp.status && resp.is_plg_user) {
                    this.setState({
                        addon_purchases: resp?.addon_purchases ?? [],
                        addonTotal: resp?.addon_total ?? 0,
                        addonPage: resp?.addon_page ?? page,
                        addonTotalPages: resp?.addon_total_pages ?? 1,
                        addonLoading: false,
                        curPlan: {code:resp?.plg_plan,calls:resp.calls_in_account} ?? null,
                    });
                } else {
                    this.setState({ addonLoading: false });
                }
            });
        });
    }

    formatCalls = (value) => {
        const num = Number(value) || 0;
        return Math.round(num).toLocaleString('en-US', { maximumFractionDigits: 0 });
    }

    formatCallsWithUnit = (value) => {
        const count = Math.round(Number(value) || 0);
        const unit = count <= 1 ? 'call' : 'calls';
        return `${this.formatCalls(count)} ${unit}`;
    }

    formatDate = (dateStr) => {
        if (!dateStr) return '—';
        return new Date(dateStr).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    }

    getAddonPackageDisplayName = (addon) => {
        return `${this.formatCalls(addon.calls_included)} Calls Pack`;
    }

    renderAddonPackagesCard = () => {
        const { addon_purchases, addonPage, addonPageSize, addonTotal, addonTotalPages, addonLoading } = this.state;
        const start = (addonPage - 1) * addonPageSize;
        const end = Math.min(start + addonPageSize, addonTotal);

        return (
            <div className="usage-card addon-packages-card">
                <div className="usage-card-body">
                    <div className="usage-card-title-row">
                        <span className="title-icon">
                            <i className="fa fa-gift" aria-hidden="true"></i>
                        </span>
                        <div>
                            <h3 className="usage-card-heading">Add-On Packages</h3>
                            <p className="usage-card-subtitle">View details of your active add-on packages.</p>
                        </div>
                    </div>
                    {addonTotal > 0 ? (
                        <>
                            <div className="addon-packages-table-wrap" style={{ opacity: addonLoading ? 0.5 : 1 }}>
                                <table className="addon-packages-table">
                                    <thead>
                                        <tr>
                                            <th>Package</th>
                                            <th>Calls</th>
                                            <th>Amount</th>
                                            <th>Purchased On</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {addon_purchases.map((row, index) => (
                                            <tr key={index}>
                                                <td><span className="addon-package-name">{row.addon_name}</span></td>
                                                <td>{this.formatCallsWithUnit(row.calls_purchased)}</td>
                                                <td className="addon-price">${Number(row.price || 0).toFixed(2)}</td>
                                                <td className="addon-purchased-on">
                                                    {row.purchase_date
                                                        ? new Date(row.purchase_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
                                                        : '—'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <small className="text-muted">
                                    Showing {addonTotal === 0 ? 0 : start + 1}-{end} of {addonTotal}
                                </small>
                                <Pagination
                                    size="mini"
                                    activePage={addonPage}
                                    totalPages={addonTotalPages}
                                    onPageChange={(e, { activePage }) => this.loadAddonPage(activePage)}
                                />
                            </div>
                        </>
                    ) : (
                        <div className="no-data-state">
                            <i className="fa fa-gift no-data-icon" aria-hidden="true"></i>
                            <p>No add-on packages purchased.</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderNonPlgUsage = () => {
        return (
            <div className="monthly-usage-container px-4">
                <div className="usage-card">
                    <div className="usage-card-body">
                        <div className="usage-card-title-row">
                            <span className="title-icon">
                                <i className="fa fa-clock-o" aria-hidden="true"></i>
                            </span>
                            <div>
                                <h3 className="usage-card-heading">Voice Usage</h3>
                                <p className="usage-card-subtitle">Overview of your voice call usage this month.</p>
                            </div>
                        </div>
                        <div className="usage-stat-item">
                            <span className="usage-stat-label">
                                <span className="usage-stat-icon-box icon-blue">
                                    <i className="fa fa-hourglass-half" aria-hidden="true"></i>
                                </span>
                                Total Minutes
                            </span>
                            <span className="usage-stat-value">
                                {this.state?.total_min ? this.state?.total_min : 0}
                            </span>
                        </div>
                        <div className="usage-stat-item">
                            <span className="usage-stat-label">
                                <span className="usage-stat-icon-box icon-yellow">
                                    <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                </span>
                                Minutes Included in Plan
                            </span>
                            <span className="usage-stat-value">
                                {this.state?.record?.mins_in_plan ?? 0}
                            </span>
                        </div>
                        <div className="usage-stat-item">
                            <span className="usage-stat-label">
                                <span className="usage-stat-icon-box icon-teal">
                                    <i className="fa fa-dollar" aria-hidden="true"></i>
                                </span>
                                Usage Cost
                            </span>
                            <span className="usage-stat-value">
                                ${this.state?.total ? this.state?.total : 0}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPlgUsage = () => {
        const {
            mins_in_plan,
            mins_used,
            remaining_calls,
            cycle_start_date,
            cycle_end_date,
            carryforward_calls,
        } = this.state;


        const isFullyUsed = remaining_calls <= 0 && mins_in_plan > 0;

        const planPrice = this.state.plan_price;
        const planCalls = this.state.plan_calls_included;
        return (
            <div className="monthly-usage-container px-4">
                <div className="usage-top-row">
                    <div className="usage-card voice-usage-card">
                        <div className="usage-card-body">
                            <div className="usage-card-title-row">
                                <span className="title-icon">
                                    <i className="fa fa-phone" aria-hidden="true"></i>
                                </span>
                                <div>
                                    <h3 className="usage-card-heading">Voice Usage</h3>
                                    <p className="usage-card-subtitle">Overview of your voice call usage this month.</p>
                                </div>
                            </div>

                            <div className="voice-usage-stats">
                                    <div className="usage-stat-item">
                                        <span className="usage-stat-label">
                                            <span className="usage-stat-icon-box icon-blue">
                                                <i className="fa fa-phone" aria-hidden="true"></i>
                                            </span>
                                            Plan
                                        </span>
                                        <span className="usage-stat-value">
                                            {planCalls > 0 || planPrice > 0
                                                ? `$${Number(planPrice).toFixed(2)}/month (${this.formatCalls(planCalls)} calls included)`
                                                : <span className="text-muted">No plan assigned</span>
                                            }
                                        </span>
                                    </div>
                                    <div className="usage-stat-item">
                                        <span className="usage-stat-label">
                                            <span className="usage-stat-icon-box icon-yellow">
                                                <i className="fa fa-phone" aria-hidden="true"></i>
                                            </span>
                                            Calls Used
                                        </span>
                                        <span className="usage-stat-value">{this.formatCalls(mins_used)}</span>
                                    </div>
                                    <div className="usage-stat-item">
                                        <span className="usage-stat-label">
                                            <span className="usage-stat-icon-box icon-teal">
                                                <i className="fa fa-gift" aria-hidden="true"></i>
                                            </span>
                                           Add-On Calls
                                        </span>
                                        <span className="usage-stat-value">{this.formatCalls(this.state.addon_calls)}</span>
                                    </div>



                                    <div className="usage-stat-item">
                                        <span className="usage-stat-label">
                                            <span className="usage-stat-icon-box icon-teal">
                                                <i className="fa fa-phone" aria-hidden="true"></i>
                                            </span>
                                            Remaining Calls
                                        </span>
                                        <span className={`usage-stat-value`}>
                                            {this.formatCalls(remaining_calls)}
                                        </span>
                                    </div>
                                     {(carryforward_calls > 0) && (
                                        <div className="usage-stat-item">
                                            <span className="usage-stat-label">
                                                <span className="usage-stat-icon-box icon-purple">
                                                     <i className="fa fa-refresh" aria-hidden="true"></i>
                                                </span>
                                               Carried Forward Add-On Calls
                                            </span>
                                            <span className='usage-stat-value'>
                                                {this.formatCalls(carryforward_calls)}
                                            </span>
                                        </div>
                                    )}

                                    <div className="usage-stat-item">
                                            <span className="usage-stat-label">
                                                <span className="usage-stat-icon-box icon-purple">
                                                    <i className="fa fa-calendar" aria-hidden="true"></i>
                                                </span>
                                               Billing Cycle
                                            </span>
                                            <span className="usage-stat-value">
                                                {cycle_start_date && cycle_end_date
                                                    ? `${this.formatDate(cycle_start_date)} - ${this.formatDate(cycle_end_date)}`
                                                    : '—'}
                                            </span>
                                        </div>
                            </div>
                        </div>
                    </div>

                    {this.renderAddonPackagesCard()}
                </div>

            </div>
        );
    }

    render() {
        if (this.state.error !== "") { }

        if (this.state.loading) {
            return (
                <div className="monthly-usage-loading">
                    <Loader active inline="centered" size="large">
                        Loading usage data...
                    </Loader>
                </div>
            );
        }

        return (
            <div className="monthly-usage-wrapper">
                {this.state.refreshing && (
                    <div className="monthly-usage-refresh-overlay">
                        <Loader active inline size="small" />
                        <span>Refreshing...</span>
                    </div>
                )}
                {this.state.is_plg_user ? this.renderPlgUsage() : this.renderNonPlgUsage()}
            </div>
        );
    }
}

export default Datatable;
